import SlideIdentifierSkeleton from './SlideIdentifier/skeleton';

const LeftPartSkeleton = () => {
  return <SlideIdentifierSkeleton />;
};

export default LeftPartSkeleton;
